import * as React from "react";
import { Component } from "react";
import { stylesheet } from "typestyle";
import { classNames } from "../utils.js";
export class KeyButton extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => this.props.onType(this.props.value);
    }
    render() {
        const { value, disabled, round, primary, border = true, children, className } = this.props;
        const classes = classNames(styles.button, round && styles.buttonRound, border && styles.buttonBorder, primary ? styles.buttonPrimary : styles.buttonTransparent, className);
        return (React.createElement("button", { className: classes, onClick: this.handleClick, disabled: disabled }, children || value));
    }
}
const styles = stylesheet({
    button: {
        flex: 1,
        border: 0,
        padding: "0.625em 0",
        $nest: {
            "&[disabled]": {
                opacity: 0.5,
            }
        },
        cursor: "pointer"
    },
    buttonTransparent: {
        backgroundColor: "transparent",
        $nest: {
            "&:active": {
                backgroundColor: "rgba(255, 255, 255, 0.5)"
            }
        }
    },
    buttonBorder: {
        borderRadius: "0.25rem",
        backgroundColor: "var(--color-background-less-contrast)",
        border: "1px solid var(--color-separator)",
    },
    buttonRound: {
        width: "2em",
        height: "2em",
        borderRadius: "50%",
        border: 0,
        textAlign: "center",
        lineHeight: "2em",
        padding: 0,
        margin: "0 0.25em",
        flex: "0 1 auto",
        $nest: {
            "&:first-child": {
                marginRight: "0.25em"
            },
            "&:last-child": {
                marginLeft: "0.25em"
            }
        },
        cursor: "pointer"
    },
    buttonPrimary: {
        display: "block",
        backgroundColor: "var(--color-primary)",
        border: 0,
        color: "#fff",
        $nest: {
            "&:active": {
                filter: "brightness(1.5)"
            }
        },
        cursor: "pointer"
    }
});
//# sourceMappingURL=KeyButton.js.map